export default "__VITE_ASSET__BQswVtH$__"